import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedApiService } from '../../../shared/service/util.service';
import { SubSocietyModel } from '../Model/sponser.model';

@Injectable({
  providedIn: 'root'
})
export class SubSocietyService {

  private endpoint = `SubSociety/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAll(): Observable<{ value: SubSocietyModel[] }> {
    return this.sharedApiService.getAll(this.endpoint);
  }
}
